export default __webpack_public_path__ + "static/media/image-30.8deb028f.png";